module.exports = __webpack_public_path__ + "img/bannerText.53bb49fc.png";